module.exports = __webpack_public_path__ + "img/banner_02.e596f9b0.png";